@import 'styles/blaze/mixins';
@import 'styles/mixins';

.container {
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin-top: 30px;

  @include for-phone-only {
    margin-top: 0;
    gap: 25px;
  }
}

.description {
  margin-top: 20px;

  span {
    font-size: 18px !important;

    @include for-desktop-only {
      [data-autopilot-system-redesign='on'] & {
        font-size: 16px !important;
      }
    }

    @include for-phone-only {
      font-size: 14px !important;
    }
  }

  @include for-phone-only {
    margin-top: 0;
  }
}

.resendEmail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrollContainer {
  margin-top: 50px;
  padding: 0;

  @include for-desktop-only {
    margin-top: 0;
  }
}

.logo {
  position: absolute;
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
}
